import React from 'react';
import { createRoot } from 'react-dom/client';

import { MQ_LARGE } from 'common/constants/MediaQueries';
import eventEmitter, { EventsTypes } from 'common/services/events/eventEmitter';
import { removeClass } from 'common/tools/dom/classes';
import { isStateBiggerThan } from 'common/tools/dom/mq-state';
import { runAfterDesobfuscation } from 'common/tools/seo/desobfuscation';

import FilterListSelect from 'website/components/ui/FilterList';

let injected = false;

export default function init() {
  runAfterDesobfuscation(() => {
    inject();
    eventEmitter.on(EventsTypes.MQ_STATE, inject);
  });
}

function inject() {
  if (injected) return;

  const placeholder = document.getElementById('filter-entity-mobile');
  if (placeholder && isStateBiggerThan(MQ_LARGE)) {
    const root = createRoot(placeholder);
    root.render(<FilterListSelect />);
    injected = true;
    removeClass(placeholder, 'loading');
  }
}
